import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  text-align: ${({ align }) => align || 'left'};
  @media (max-width: 768px) {
    margin-bottom: 34px;
  }
`;
const Title = styled.h3`
  font-size: 40px;
  font-weight: 500;
  color: ${(props) => props.theme.palette.text.primary};
  margin-bottom: 16px;
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;
const Caption = styled.p`
  font-size: 16px;
  line-height: 1.51;
  color: ${(props) => props.theme.palette.text.secondary};
`;

const TitleSection = ({ title, caption, align }) => {
  return (
    <Wrapper align={align}>
      <Title>{title}</Title>
      <Caption>{caption}</Caption>
    </Wrapper>
  );
};

export default TitleSection;
